import { InjectionToken } from "@angular/core";

export interface SolSessionTimeoutOptions {
  /** Time in second before the session timeout is triggered  */
  idleTime?: number;
}

export const SOL_SESSION_TIMEOUT_OPTIONS = new InjectionToken("SOL_SESSION_TIMEOUT_OPTIONS");
